import {connect} from 'react-redux';
import TrackerTag from './tracker';

export default connect(({usersMap, overviewByTrackers, issuesMap, pushIssues}) => ({
    usersMap,
    overviewByTrackers,
    issuesMap,
    pushIssues
}))(TrackerTag);


// WEBPACK FOOTER //
// ./src/components/schedule/issues/tracker/index.js